import React, { useState } from "react";
import { Copyright, Home } from "@mui/icons-material";
import RegisterBookContent from "../../../../../components/reg_book/RegisterBookContent";
import { useGetRegBookCopyrightQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import Loader from "../../../../../components/custom/Loader";
import CopyrightTable from "../../../../../components/reg_book/CopyrightTable";

const RegisterBookCopyright = () => {
  const bookType = 1;
  const [regNo, setRegNo] = useState("");
  const [trackReg, setTrackReg] = useState("");
  const { data, isLoading } = useGetRegBookCopyrightQuery({
    bookType,
    trackReg,
    registration_no: regNo,
  });
  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    {
      icon: Copyright,
      title: "কপিরাইট - রেজিস্টার বুক",
      active: true,
    },
  ];
  const applicationPath = {
    copyright: "/admin/register-book-copyright",
    agreement: "/admin/register-book-agreement",
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <RegisterBookContent
      data={data}
      trackReg={trackReg}
      setTrackReg={setTrackReg}
      regNo={regNo}
      setRegNo={setRegNo}
      showRegNo={true}
      content={<CopyrightTable data={data} />}
      breadcrumbsData={breadcrumbsData}
      applicationPath={applicationPath}
    />
  );
};

export default RegisterBookCopyright;
